<script lang="ts">
    export let value = null;
    export let label;
    export let name;
    export let placeholder;
    export let error = null;
</script>

<div class="field">
    <label class="label" for={name}>{label}</label>
    <div class="control">
        <textarea bind:value class="textarea" id={name} name={name} placeholder={placeholder} {...$$restProps}></textarea>
    </div>
    {#if error}
        <p class="help is-danger">{error}</p>
    {/if}
</div>